/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

document.addEventListener('DOMContentLoaded', function () {
  const tooltip = document.getElementById('visa-giftcard-tooltip');
  if (!tooltip) return;

  const closeBtn = tooltip.querySelector('.visa-tooltip__close');

  // Any announcement bar link pointing to #visa-giftcard
  const triggers = document.querySelectorAll('a[href="#announcement-bar"]');

  function openTooltip() {
    tooltip.removeAttribute('hidden');
  }

  function closeTooltip() {
    if (!tooltip.hasAttribute('hidden')) {
      tooltip.setAttribute('hidden', 'hidden');
    }
  }

  triggers.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault(); // no scrolling / navigation
      // Toggle behavior: click again to close
      if (tooltip.hasAttribute('hidden')) {
        openTooltip();
      } else {
        closeTooltip();
      }
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closeTooltip();
    });
  }

  // Close on click outside
  document.addEventListener('click', function (e) {
    if (tooltip.hasAttribute('hidden')) return;
    if (tooltip.contains(e.target)) return;
    // don't close when clicking the announcement link itself,
    // that is already handled above
    if (e.target.closest('a[href="#announcement-bar"]')) return;
    closeTooltip();
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeTooltip();
    }
  });
});